module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.invoice && _vm.invoice.id) ? _c('statement', {
    attrs: {
      "client": _vm.invoiceClient,
      "with-selectable": true,
      "with-reload": true,
      "with-pre-next": false,
      "with-filters": false,
      "with-client-preview": false,
      "loading": _vm.statementRequest.loading
    },
    on: {
      "reload": _vm.getStatement
    },
    model: {
      value: (_vm.statement),
      callback: function($$v) {
        _vm.statement = $$v
      },
      expression: "statement"
    }
  }, [_c('template', {
    slot: "subheader"
  }, [_vm._t("subheader")], 2)], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dc7e429","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/InvoicePayments.vue
// module id = 1482
// module chunks = 9